module.exports = __webpack_public_path__ + "static/img/home_bg_jinrong.fe51ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/home_bg_jinrong.png
// module id = 3ieV
// module chunks = 1